import React, { useEffect } from 'react';
import { XCircle, ArrowLeft } from 'lucide-react';

const AuthError = () => {
  const [message, setMessage] = React.useState('Une erreur est survenue lors de l\'authentification.');

  useEffect(() => {
    // Récupérer le message d'erreur depuis l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const errorMessage = urlParams.get('message');
    if (errorMessage) {
      setMessage(decodeURIComponent(errorMessage));
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Erreur d'authentification
        </h2>
        <p className="text-gray-500 mb-6">{message}</p>
        <button
          onClick={() => (window.location.href = '/')}
          className="inline-flex items-center gap-2 bg-[#27489E] text-white px-6 py-3 rounded-xl font-semibold hover:bg-[#1e3a7d] transition"
        >
          <ArrowLeft className="w-5 h-5" />
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
};

export default AuthError;

